import { __assign, __extends } from "tslib";
import * as _get from 'lodash/get';
import { SubReducerBase } from './reducers';
var MarkChatroomReadSubReducer = /** @class */ (function (_super) {
    __extends(MarkChatroomReadSubReducer, _super);
    function MarkChatroomReadSubReducer(config) {
        return _super.call(this, config) || this;
    }
    MarkChatroomReadSubReducer.prototype.reduce = function (state, action) {
        var chatroomId = _get(action, ['data', 'chatroomId']);
        if (this.isInTrackingOverflowState(state)) {
            return __assign(__assign({}, state), { 
                // @ts-ignore
                resyncCountdown: Math.max(state.resyncCountdown - 1, 0) });
        }
        if (this.isChatroomUnread(state, chatroomId)) {
            return this.removeFromUnreads(state, chatroomId);
        }
        return state;
    };
    MarkChatroomReadSubReducer.prototype.removeFromUnreads = function (state, chatroomId) {
        // @ts-ignore
        var chatroomsCount = state.chatroomsCount - 1;
        var chatroomIds = __assign({}, state.chatroomIds);
        delete chatroomIds[chatroomId];
        return __assign(__assign({}, state), { chatroomIds: chatroomIds,
            chatroomsCount: chatroomsCount, resyncCountdown: undefined });
    };
    return MarkChatroomReadSubReducer;
}(SubReducerBase));
export default MarkChatroomReadSubReducer;
